export default function InstructorModeTabs({ tab, onChange }) {
  const tabs = [
    ["QUICK_DAILY_FEEDBACK", "Quick Daily Feedback"],
    ["DETAILED_ASSESSMENT", "Detailed Assessment"],
    ["MOCK_READINESS", "Mock / Readiness"],
    ["QUICK_LESSON", "Quick Lesson"],
  ];

  return (
    <div className="audit-mode-tabs" role="tablist" aria-label="Training workflow" data-testid="workflow-tabs">
      {tabs.map(([id, label]) => (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={tab === id}
          className="audit-mode-tab"
          onClick={() => onChange(id)}
          data-testid={`tab-${id}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
